import { withVersions } from "v2/hocs/withVersions";
import withPreferencesDrawer from "../hocs/withPreferencesDrawer";
import { PreferencesDrawer as PreferencesDrawerV1 } from "./PreferencesDrawer/v1";
import { PreferencesDrawer as PreferencesDrawerV2 } from "./PreferencesDrawer/v2";

const PreferencesDrawer = withVersions({
  v1: withPreferencesDrawer(PreferencesDrawerV1),
  v2: withPreferencesDrawer(PreferencesDrawerV2),
});

export { PreferencesDrawer };
